<template>
	<div class="modal fade" role="dialog" aria-labelledby="closeAsignacionVendedorLabel" aria-hidden="true" data-keyboard="false" data-backdrop="static">
		<div class="modal-dialog modal-dialog-scrollable modal-dialog-centered" role="document">
			<div class="modal-content">
				<div class="modal-header">
					<h5 class="modal-title" id="closeAsignacionVendedorLabel">
						<i class="material-icons">recent_actors</i> Asignar Vendedor
					</h5>
					<button type="button" class="close" data-dismiss="modal" aria-label="Close">
						<span aria-hidden="true">&times;</span>
					</button>
				</div>
				<div class="modal-body">
					<preloader v-if="loading"></preloader>
					<div class="form-row">
						<label for="vendedor">Seleccionar</label>
						<catalogo-vendedores-todos id="vendedor" v-model="form.vendedor"></catalogo-vendedores-todos>
						<div 
                    		class="text-danger" 
                    		v-if="errors.vendedor">
                    		{{errors.vendedor[0]}}
                    	</div>
					</div>
					
				</div>
				<div class="modal-footer">
					<button type="button" class="btn btn-primary" v-on:click.prevent="asignar">
						Asignar vendedor
					</button>
					<button type="button" class="btn btn-secondary" v-on:click.prevent="closeModal">
						Cancelar
					</button>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
	export default {
		data(){
			return {
				loading: false,
				oportunidad: '',

				form: {
					vendedor: ''
				},
				errors: {}
			}
		},

		mounted(){
			var vm = this;
			$(this.$el).on('shown.bs.modal', function (event) {
				var button = $(event.relatedTarget)
				vm.form.vendedor = button.data('vendedor')
				vm.oportunidad = button.data('oportunidad')
			});
		},

		methods: {
			asignar: function(){
				this.loading = true
				var url = 'api/oportunidades/'+this.oportunidad+'/asignar/vendedor'

				axios.post(url, {
					vendedor: this.form.vendedor
				})
				.then(response => {
					this.$toasted.show(response.data || 'El vendedor ha sido asignado')
					this.cleanFields()
					window.location.href = crm.route.oportunidades.index
				}).catch(error => {
					this.$toasted.show('Error al asignar')
					console.log(error.response)
					if (error.response) {
						if (typeof error.response.data === 'string') {
							this.$toasted.show(error.response.data)
						}
					}
					
				}).then(()=>{
					this.loading = false
				})
			},
			
			cleanFields: function(){
				this.form.vendedor = ''
			},

			closeModal: function(){
				$(this.$el).modal('hide')
			}
		}
	}
</script>